export const EDITOR_TOP = 90;
export const EDITOR_WIDTH = 440;
export const EDITOR_MENU_WIDTH = 50;
export const EDITOR_CONTENT_WIDTH = EDITOR_WIDTH - EDITOR_MENU_WIDTH;
